export default "__VITE_ASSET__qN3dprkB__"